
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/open-source/@blognami/main/lib/views/_gtag.js";
                const hash = "oOuRsrJZ3B";
                Component.include(createDecoratorsInclude(hash, decorators));
            